import { render, staticRenderFns } from "./DatePickerCustom.vue?vue&type=template&id=2e489ce1&"
import script from "./DatePickerCustom.vue?vue&type=script&lang=js&"
export * from "./DatePickerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports